import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const NotFound = () => {
  return (
    <Box>
      <Typography variant='h4' component='h1' gutterBottom>
        Page not found
      </Typography>
      <Typography variant='body1'>The page could not be found</Typography>
    </Box>
  );
};

export default NotFound;
